module.exports = __webpack_public_path__ + "static/media/oswaldo_aranda_rata.5625ac99.png";